import { Component, OnInit , ElementRef, Renderer2, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';


@Component({
  selector: 'echexpayment-echexmerchant',
  templateUrl: './addechexmerchant.component.html',
  styleUrls: ['./echexmerchant.component.css']
})
export class AddechexmerchantComponent implements OnInit {
	echexMerchant: any = {};
	public token: string;
	public id: string;
    busy: Subscription;
	public val_first_name : boolean=false;
	public val_email : boolean=false;
	public val_last_name : boolean=false;
  @ViewChild('submitButton') submitButton: ElementRef;

  NamecharacterLimitReached: { [key: string]: boolean } = {};
  
	constructor(private router: Router, private toastr: ToastrService, private renderer: Renderer2, private elementRef: ElementRef, private userService :UserService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
		this.router = router;
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
		let userDetails = this.localStorageService.getData("currentUser");
		this.id = userDetails._id;

	}

	ngOnInit() {
	}
	
	eventHandler(){
      this.val_first_name = false;
      this.val_last_name = false;
      this.val_email = false;
  }

  ngAfterViewInit() {
    this.renderer.selectRootElement('#InitialFocus').focus();
  }

 
  // Enter Key Focus Next Field
  moveNext(nextInput: HTMLInputElement, checkbox) {
      if(checkbox === 2){
        if (this.submitButton && this.submitButton.nativeElement) {
          this.submitButton.nativeElement.focus();
          this.submitButton.nativeElement.click();
        }
      } else{
          nextInput && nextInput.focus();
      }
  }
  // Focus Error Field
	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	}

	// Add Merchant from super admin
	createEchexMerchant(data) {
    this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid){
			    let model: any = data.value;
          this.val_first_name = false;
          this.val_last_name = false;
          this.val_email = false;
          var EMAIL_REGEXP = /[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;

          if(typeof model.first_name === 'undefined'  || model.first_name === null || model.first_name === ''){
            this.val_first_name = true;
            return false;
          }

          if(typeof model.last_name === 'undefined'  || model.last_name === null || model.last_name === ''){
            this.val_last_name = true;
            return false;
          }

          if(typeof model.email === 'undefined'  || model.email === null || model.email === ''){
            this.val_email = true;
            return false;
          }
        
          if( !EMAIL_REGEXP.test(model.email)){
                this.val_email = true;
                return false;
            }
          model.token = this.token
          model.user_token = this.token
          model.id = this.id
          let responseData = <any>{};
          this.busy = this.echexpaymentService.createEchexMerchantApi(model).subscribe(
              response => {
            responseData = response;
                  this.toastr.success(responseData.message, 'Success!');
                  this.router.navigate(['/echex-merchant']);
              },
            error => {
            responseData = error;
              this.toastr.error(responseData.error.message, 'Failed!');       
            }
          );
      }
  }

  	// characters Limit check
	NameCharacterLimit(event: any, fieldName: string) {
		const maxTextLength = 25; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
	  
		const inputValue = event.target.value;
	  
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
			this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
			setTimeout(() => {
			  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
			}, 3000);
			event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	}
	  
  isNameLimitReached(fieldName: string): boolean {
      return this.NamecharacterLimitReached[fieldName];
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexmerchant/addechexmerchant.component.ts